import React from 'react';
import styled from 'styled-components';
import { Calendar, CalendarInactive, CalendarWithCheck } from 'src/svg/calendar';

type ScheduleCalendarIconProps = {
  variant?: 'default' | 'inactive' | 'with-check';
  disabled?: boolean;
  className?: string;
};

const ICON_MAP = {
  default: Calendar,
  inactive: CalendarInactive,
  'with-check': CalendarWithCheck,
};

export function ScheduleCalendarIcon({
  variant = 'default',
  disabled = false,
  className,
}: ScheduleCalendarIconProps): JSX.Element {
  const IconComponent = ICON_MAP[variant];

  return <StyledIcon as={IconComponent} disabled={disabled} className={className} />;
}

const StyledIcon = styled.svg<{ disabled?: boolean }>`
  width: 14px;
  height: 14px;
  margin-right: 8px;
  color: ${({ disabled }) => (disabled ? '#969EA5' : '#677882')};
  position: relative;
  top: -1px;
`;
